import React, { useCallback } from "react";
import { FormItemProps } from "./FormItem.props";
import { COMPONENT_TYPES_ENUM, COOKIE_KEY, FILE_FORM_API, LANG_KEY } from "../../../../../constants";
import {
  Checkbox, Col,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  InputNumber,
  List, message,
  Radio, Row,
  Select,
  Slider, Tooltip,
  Typography, Upload
} from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import 'dayjs/locale/ru.js';
import locale from 'antd/locale/ru_RU';

import isBetween from "dayjs/plugin/isBetween"
import { MyButton } from "../../../MyButton/MyButton";
import axios from "axios";
import { getFromUrl } from "../../../../../utils/getFromUrl";
import { Cookies } from "react-cookie";
import { MyPasswordTest } from "../../../MyInput/MyInput";

dayjs.extend(isBetween)
const cookies = new Cookies()

export const FormItem = ({ item, object }: FormItemProps): React.ReactElement => {
  const { t } = useTranslation("common")

  const FILE_TYPE = {
    PDF: 'application/pdf',
    DOC: 'application/msword',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    XLS: 'application/vnd.ms-excel',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }

  const renderType = useCallback((field: any) => {
    switch (field?.type) {
      case COMPONENT_TYPES_ENUM.TYPE_TEXT:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} autoComplete={'new-password'}
            disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_NUMBER:
        return (
          <InputNumber max={field?.max ? field?.max : 100} min={field?.min ? field?.min : 0} placeholder={field?.placeholder ? field?.placeholder : ''}
            autoComplete={'new-password'} disabled={field?.is_disabled} step={field?.step} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_PASSWORD:
        return (
          <MyPasswordTest placeholder={field?.placeholder ? field?.placeholder : ''} type={"password"}
            autoComplete={'new-password'} disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_TEL:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"tel"} autoComplete={'new-password'}
            disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_EMAIL:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"email"} autoComplete={'new-password'}
            disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_URL:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"url"}
            autoComplete={'new-password'} disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_DATE:
        console.log('field', field)
        console.log('item', item)
        return (
          <DatePicker
            style={{ width: '100%' }}
            format={"YYYY-MM-DD"}
            placeholder={field?.placeholder ? field?.placeholder : ''}
            disabledDate={(currentDate: any) => (object?.start_date || object?.end_date)
              ? !dayjs(currentDate).isBetween(object?.start_date, object?.end_date, 'days', '[]')
              : false}
            autoComplete={'new-password'}
            disabled={field?.is_disabled}
          />
        )
      case COMPONENT_TYPES_ENUM.TYPE_DATE_AT:
        return (
          <DatePicker
            style={{ width: '100%' }}
            format={"YYYY-MM-DD"}
            placeholder={field?.placeholder ? field?.placeholder : ''}
            disabledDate={(currentDate: any) => (object?.start_date || object?.end_date)
              ? !dayjs(currentDate).isBetween(object?.start_date, object?.end_date, 'days', '[]')
              : false
            }
            autoComplete={'new-password'}
            disabled={field?.is_disabled}
          />
        )
      case COMPONENT_TYPES_ENUM.TYPE_DATETIME_LOCAL:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"datetime-local"}
            autoComplete={'new-password'} disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_TIME:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"time"} autoComplete={'new-password'}
            disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_WEEK:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"week"} autoComplete={'new-password'}
            disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_MONTH:
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"month"} autoComplete={'new-password'}
            disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_TEXTAREA:
        return (
          <Input.TextArea placeholder={field?.placeholder ? field?.placeholder : ''} rows={4}
            autoComplete={'new-password'} disabled={field?.is_disabled} />
        );
      case COMPONENT_TYPES_ENUM.TYPE_CHECKBOX:
        return (
          <Checkbox disabled={field?.is_disabled}>{field?.label}</Checkbox>
        );
      case COMPONENT_TYPES_ENUM.TYPE_RADIO:
        return (
          <Radio.Group disabled={field?.is_disabled}>
            {field?.fieldValues?.map((field: any, index: any) => (
              <Radio.Button value={field.value} key={"TYPE_RADIO" + index}>
                {field.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        );
      case COMPONENT_TYPES_ENUM.TYPE_SELECT:
        return (
          <Select placeholder={field?.placeholder ? field?.placeholder : ''} disabled={field?.is_disabled}>
            {field?.fieldValues?.map((fieldInner: any, index: any) => (
              <Select.Option value={fieldInner.value} key={"TYPE_SELECT" + index}>
                {fieldInner.label}
              </Select.Option>
            ))}
          </Select>
        );
      case COMPONENT_TYPES_ENUM.TYPE_DATALIST:
        return (
          <List>
            {field?.fieldValues?.map((fieldInner: any, index: any) => (
              <List.Item key={"TYPE_DATALIST" + index}>
                <Typography.Text>{fieldInner}</Typography.Text>
              </List.Item>
            ))}
          </List>
        );
      case COMPONENT_TYPES_ENUM.TYPE_SELECT2:
        return (
          <Select placeholder={field?.placeholder ? field?.placeholder : ''} disabled={field?.is_disabled}>
            {field?.fieldValues?.map((fieldInner: any, index: any) => (
              <Select.Option value={fieldInner.value} key={"TYPE_SELECT2" + index}>
                {fieldInner.label}
              </Select.Option>
            ))}
          </Select>

        );
      case COMPONENT_TYPES_ENUM.TYPE_COLOR: {
        return (
          <Input placeholder={field?.placeholder ? field?.placeholder : ''} type={"color"}
            disabled={field?.is_disabled} />
        );
      }
      case COMPONENT_TYPES_ENUM.TYPE_FILE: {
        //todo: сделать разделение на проверку типа файла
        const formatCheck = (file: any, fileList: any) => {
          switch (file.type) {
            case FILE_TYPE.DOC:
            case FILE_TYPE.DOCX:
            case FILE_TYPE.PDF:
            case FILE_TYPE.XLS:
            case FILE_TYPE.XLSX:
              return true

            default:
              message.error(`${file.name} is not a DOC, DOCX, PDF, XLS, XLSX  file`);
              return Upload.LIST_IGNORE
          }
        }
        const importHandler = async (option: any) => {
          const { onSuccess, onError, file, onProgress } = option;

          let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN)
          let lang = cookies.get(COOKIE_KEY.LANG) || (getFromUrl(COOKIE_KEY.LANG_OLD) ?? getFromUrl(COOKIE_KEY.LANG)) || LANG_KEY.RU

          let formData = new FormData();

          // let url: string = (file.type === FILE_TYPE.DOC || file.type === FILE_TYPE.DOCX || file.type === FILE_TYPE.PDF) ? FILE_FORM_API.FILE : FILE_FORM_API.EXCEL

          let url = FILE_FORM_API.FILE

          formData.append("yModel", 'Upload');
          formData.append("Upload[file]", file);
          formData.append("Upload[name]", file.name);

          const config = {
            headers: {
              "Authorization": `Bearer ${token}`,
              "Accept-Language": lang
            },
            onUploadProgress: (e: any) => {
              const percent = Math.floor((e.loaded / e.total) * 100)
              onProgress({ percent: percent })
            }
          }

          try {
            const res = await axios.post(url, formData, config).then((data) => {
              onSuccess(data);

              return data
            })
          } catch (e) {
            onError({ e });
          }
        }

        return (
          <Upload
            beforeUpload={(file, fileList) => formatCheck(file, fileList)}
            customRequest={(option) => importHandler(option)}
            multiple={true}
            disabled={field?.is_disabled}
          >
            <MyButton title={"Выберите файл"} />
          </Upload>
        );
      }
      case COMPONENT_TYPES_ENUM.TYPE_RANGE: {
        return (
          <Slider range disabled={field?.is_disabled} />
        );
      }
      case COMPONENT_TYPES_ENUM.TYPE_MARKS: {
        return (
          <Radio.Group disabled={field?.is_disabled}>
            {field?.fieldValues?.map((button: any, idx: any) => (
              button.tooltip ? (
                <Tooltip title={button.tooltip} key={"radio-marks-tooltip" + idx}>
                  <Radio.Button value={button.value}>
                    {button.label}
                  </Radio.Button>
                </Tooltip>
              ) : (
                <Radio.Button value={button.value} key={"radio-marks" + idx}>
                  {button.label}
                </Radio.Button>
              )
            ))}
          </Radio.Group>
        );
      }
      case COMPONENT_TYPES_ENUM.TYPE_GROUP_ONE_LINE:
        return (
          <Row gutter={[8, 8]} align='middle'>
            {
              field?.groupFields?.map((fieldInner: any, fieldIndex: number) => {
                return (
                  <Col key={fieldIndex} span={24 / field?.groupFields?.length}>
                    <Form.Item
                      name={fieldInner?.name}
                      rules={[
                        { required: fieldInner?.is_required, message: `${t('setRequiredFields')}` },
                      ]}
                      {...conditionalValues(fieldInner)}
                    >
                      {renderType(fieldInner)}
                    </Form.Item>
                  </Col>
                )
              })
            }
          </Row>
        )
      default: {
        return false;
      }
    }
  }, [])

  const conditionalValues = useCallback((field: any) => {
    switch (field.type) {
      case COMPONENT_TYPES_ENUM.TYPE_CHECKBOX:
        return {
          valuePropName: 'checked',
          wrapperCol: {
          }
        }
      case COMPONENT_TYPES_ENUM.TYPE_RADIO:
        return {
          wrapperCol: {
          }
        }
      case COMPONENT_TYPES_ENUM.TYPE_GROUP_ONE_LINE:
        return {
          wrapperCol: {
            span: 24,
            flex: 1
          },
          align: 'middle'
        }
      case COMPONENT_TYPES_ENUM.TYPE_FILE:
        return {
          valuePropName: 'file',
          wrapperCol: {
            offset: 10
          },
          getValueFromEvent: (args: any) => {
            return args.fileList?.map((item: any) => item?.response?.data?.url)
          }
        }

      default:
        return {
          label: field?.label,
          align: 'middle',
          labelCol: {
            span: 12
          },
          wrapperCol: {
            span: 12,
            flex: 1
          },
          extra: field.help,
        }
    }
  }, [])

  return (
    <ConfigProvider locale={locale}>
      {renderType(item)
        ?
        <Form.Item
          name={item?.name}
          rules={[
            { required: item?.is_required, message: `${t('setRequiredFields')}` },
          ]}
          {...conditionalValues(item)}
        >
          {renderType(item)}
        </Form.Item>
        :
        <Form.Item style={{ display: "none" }}> </Form.Item>}
    </ConfigProvider>
  )
}